import { Claims } from '@/_shared/constants';

export enum UserStatusEnum {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
  Pending = 'Pending',
}

export type UserDetails = {
  firstName: string;
  lastName: string;
  idp: string;
  status: UserStatusEnum;
  email: string;
  language: 'it' | 'en';
};

export type ValueOfClaims = `${Claims}`;

export type Claim = ValueOfClaims[];

export type UserProfile = UserDetails & {
  roles: string[];
  claims: ValueOfClaims[];
};
